import { Job } from './Job'
import { loadseaImportJobRelated } from '@/api/SeaImport/seaImportJob'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { sortByMultiFieldAndOrder } from '@/utils'
import { SeaImCargoDoc } from './SeaImCargoDoc'
export class SeaImportJob extends Job {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'SeaImportJob'
  }
  //  ======================非数据库字段===========

  get masterJobNo() {
    return this._data.masterJobNo
  }

  set masterJobNo(masterJobNo) {
    this._data.masterJobNo = masterJobNo || ''
  }

  get paymentPlaceMbl() {
    return this._data.paymentPlaceMbl
  }

  set paymentPlaceMbl(paymentPlaceMbl) {
    this._data.paymentPlaceMbl = paymentPlaceMbl || ''
  }

  get paymentPlaceHbl() {
    return this._data.paymentPlaceHbl
  }

  set paymentPlaceHbl(paymentPlaceHbl) {
    this._data.paymentPlaceHbl = paymentPlaceHbl || ''
  }

  get warehouseCmp() {
    return this._data.warehouseCmp
  }

  set warehouseCmp(warehouseCmp) {
    this._data.warehouseCmp = warehouseCmp || ''
  }
  // 渠道单号
  get channelNo() {
    return this._data.channelNo
  }
  set channelNo(channelNo) {
    this._data.channelNo = channelNo
  }
  //  ======================非数据库字段===========

  get containerLoadType() {
    return this._data.containerLoadType
  }

  set containerLoadType(containerLoadType) {
    this._data.containerLoadType = containerLoadType || ''
  }

  get hbl() {
    return this._data.hbl
  }

  set hbl(hbl) {
    this._data.hbl = hbl || ''
  }

  get cargoBulkDetail() {
    return this._data.cargoBulkDetail
  }
  set cargoBulkDetail(cargoBulkDetail) {
    this._data.cargoBulkDetail = cargoBulkDetail
  }

  get incoTerm() {
    return this._data.incoTerm
  }

  set incoTerm(incoTerm) {
    this._data.incoTerm = incoTerm || ''
  }

  get portDistrict() {
    return this._data.portDistrict
  }

  set portDistrict(portDistrict) {
    this._data.portDistrict = portDistrict || ''
  }

  get freightTermMBL() {
    return this._data.freightTermMBL
  }

  set freightTermMBL(freightTermMBL) {
    this._data.freightTermMBL = freightTermMBL || ''
  }

  get freightTermHBL() {
    return this._data.freightTermHBL
  }

  set freightTermHBL(freightTermHBL) {
    this._data.freightTermHBL = freightTermHBL || ''
  }

  get releaseType() {
    return this._data.releaseType
  }

  set releaseType(releaseType) {
    this._data.releaseType = releaseType || 0
  }

  get paymentPlace() {
    return this._data.paymentPlace
  }

  set paymentPlace(paymentPlace) {
    this._data.paymentPlace = paymentPlace || ''
  }

  get transDate() {
    return this._data.transDate
  }

  set transDate(transDate) {
    this._data.transDate = transDate
  }

  get releaseDate() {
    return this._data.releaseDate
  }

  set releaseDate(releaseDate) {
    this._data.releaseDate = releaseDate
  }

  get deliverDate() {
    return this._data.deliverDate
  }

  set deliverDate(deliverDate) {
    this._data.deliverDate = deliverDate
  }

  get esd() {
    return this._data.esd
  }

  set esd(esd) {
    this._data.esd = esd
  }

  get returnDate() {
    return this._data.returnDate
  }

  set returnDate(returnDate) {
    this._data.returnDate = returnDate
  }

  get releaseTypeMbl() {
    return this._data.releaseTypeMbl
  }

  set releaseTypeMbl(releaseTypeMbl) {
    this._data.releaseTypeMbl = releaseTypeMbl || 0
  }

  get releaseTypeHbl() {
    return this._data.releaseTypeHbl
  }

  set releaseTypeHbl(releaseTypeHbl) {
    this._data.releaseTypeHbl = releaseTypeHbl || 0
  }

  get secondVessel() {
    return this._data.secondVessel
  }

  set secondVessel(secondVessel) {
    this._data.secondVessel = secondVessel || ''
  }

  get secondVoyage() {
    return this._data.secondVoyage
  }

  set secondVoyage(secondVoyage) {
    this._data.secondVoyage = secondVoyage || ''
  }

  get trans() {
    return this._data.trans
  }

  set trans(trans) {
    this._data.trans = trans || false
  }

  get customs() {
    return this._data.customs
  }

  set customs(customs) {
    this._data.customs = customs || false
  }

  get customDate() {
    return this._data.customDate
  }

  set customDate(customDate) {
    this._data.customDate = customDate
  }

  get parts() {
    return this._data.parts
  }

  set parts(parts) {
    this._data.parts = parts || false
  }

  get quarantine() {
    return this._data.quarantine
  }

  set quarantine(quarantine) {
    this._data.quarantine = quarantine || false
  }

  get arriveStorageDate() {
    return this._data.arriveStorageDate
  }

  set arriveStorageDate(arriveStorageDate) {
    this._data.arriveStorageDate = arriveStorageDate
  }

  get customsHbl() {
    return this._data.customsHbl
  }

  set customsHbl(customsHbl) {
    this._data.customsHbl = customsHbl || ''
  }

  get vesselUnCode() {
    return this._data.vesselUnCode
  }

  set vesselUnCode(vesselUnCode) {
    this._data.vesselUnCode = vesselUnCode || ''
  }

  get deliverRemarks() {
    return this._data.deliverRemarks
  }

  set deliverRemarks(deliverRemarks) {
    this._data.deliverRemarks = deliverRemarks || ''
  }

  get arriveStorageRemarks() {
    return this._data.arriveStorageRemarks
  }

  set arriveStorageRemarks(arriveStorageRemarks) {
    this._data.arriveStorageRemarks = arriveStorageRemarks || ''
  }

  get customerRemarks() {
    return this._data.customerRemarks
  }

  set customerRemarks(customerRemarks) {
    this._data.customerRemarks = customerRemarks || ''
  }

  get customsNo() {
    return this._data.customsNo
  }

  set customsNo(customsNo) {
    this._data.customsNo = customsNo || ''
  }

  get vesselChineseName() {
    return this._data.vesselChineseName
  }

  set vesselChineseName(vesselChineseName) {
    this._data.vesselChineseName = vesselChineseName || ''
  }

  get loadingPortOp() {
    return this._data.loadingPortOp
  }

  set loadingPortOp(loadingPortOp) {
    this._data.loadingPortOp = loadingPortOp || 0
  }

  get destinationPortOp() {
    return this._data.destinationPortOp
  }

  set destinationPortOp(destinationPortOp) {
    this._data.destinationPortOp = destinationPortOp || 0
  }

  get bookingTerm() {
    return this._data.bookingTerm
  }

  set bookingTerm(bookingTerm) {
    this._data.bookingTerm = bookingTerm || ''
  }

  get scNo() {
    return this._data.scNo
  }

  set scNo(scNo) {
    this._data.scNo = scNo || ''
  }

  get insideQuantity() {
    return this._data.insideQuantity
  }

  set insideQuantity(insideQuantity) {
    this._data.insideQuantity = insideQuantity || 0
  }

  get insidePacking() {
    return this._data.insidePacking
  }

  set insidePacking(insidePacking) {
    this._data.insidePacking = insidePacking || ''
  }

  get vesselCode() {
    return this._data.vesselCode
  }

  set vesselCode(vesselCode) {
    this._data.vesselCode = vesselCode || ''
  }

  get freeDemurrage() {
    return this._data.freeDemurrage
  }
  set freeDemurrage(freeDemurrage) {
    this._data.freeDemurrage = freeDemurrage
  }
  get freeDetention() {
    return this._data.freeDetention
  }
  set freeDetention(freeDetention) {
    this._data.freeDetention = freeDetention
  }
  get barge() {
    return this._data.barge
  }

  set barge(barge) {
    this._data.barge = barge || false
  }

  get bargeVessel() {
    return this._data.bargeVessel
  }

  set bargeVessel(bargeVessel) {
    this._data.bargeVessel = bargeVessel || ''
  }

  get bargeVoyage() {
    return this._data.bargeVoyage
  }

  set bargeVoyage(bargeVoyage) {
    this._data.bargeVoyage = bargeVoyage || ''
  }

  get subTenantId() {
    return this._data.subTenantId
  }

  set subTenantId(subTenantId) {
    this._data.subTenantId = subTenantId || 0
  }

  get terminalCompany() {
    return this._data.terminalCompany
  }
  set terminalCompany(terminalCompany) {
    this._data.terminalCompany = terminalCompany
  }
  get deliveryAddress() {
    return this._data.deliveryAddress
  }
  set deliveryAddress(deliveryAddress) {
    this._data.deliveryAddress = deliveryAddress
  }
  get arrivalTime() {
    return this._data.arrivalTime
  }
  set arrivalTime(arrivalTime) {
    this._data.arrivalTime = arrivalTime
  }
  set estimatedArrivalTime(estimatedArrivalTime) {
    this._data.estimatedArrivalTime = estimatedArrivalTime
  }
  get estimatedArrivalTime() {
    return this._data.estimatedArrivalTime
  }
  get actualArrivalTime() {
    return this._data.actualArrivalTime
  }
  set actualArrivalTime(actualArrivalTime) {
    this._data.actualArrivalTime = actualArrivalTime
  }
  get estimatedPortDischargeTime() {
    return this._data.estimatedPortDischargeTime
  }
  set estimatedPortDischargeTime(estimatedPortDischargeTime) {
    this._data.estimatedPortDischargeTime = estimatedPortDischargeTime
  }
  get portDischargeTime() {
    return this._data.portDischargeTime
  }
  set portDischargeTime(portDischargeTime) {
    this._data.portDischargeTime = portDischargeTime
  }
  get estimatedRailwayDepartureTime() {
    return this._data.estimatedRailwayDepartureTime
  }
  set estimatedRailwayDepartureTime(estimatedRailwayDepartureTime) {
    this._data.estimatedRailwayDepartureTime = estimatedRailwayDepartureTime
  }
  get railwayDepartureTime() {
    return this._data.railwayDepartureTime
  }
  set railwayDepartureTime(railwayDepartureTime) {
    this._data.railwayDepartureTime = railwayDepartureTime
  }
  get estimatedRailwayDischargeTime() {
    return this._data.estimatedRailwayDischargeTime
  }
  set estimatedRailwayDischargeTime(estimatedRailwayDischargeTime) {
    this._data.estimatedRailwayDischargeTime = estimatedRailwayDischargeTime
  }
  get railwayDischargeTime() {
    return this._data.railwayDischargeTime
  }
  set railwayDischargeTime(railwayDischargeTime) {
    this._data.railwayDischargeTime = railwayDischargeTime
  }
  get estimatedArrivalPlaceOfDelivery() {
    return this._data.estimatedArrivalPlaceOfDelivery
  }
  set estimatedArrivalPlaceOfDelivery(estimatedArrivalPlaceOfDelivery) {
    this._data.estimatedArrivalPlaceOfDelivery = estimatedArrivalPlaceOfDelivery
  }
  get actualArrivalPlaceOfDelivery() {
    return this._data.actualArrivalPlaceOfDelivery
  }
  set actualArrivalPlaceOfDelivery(actualArrivalPlaceOfDelivery) {
    this._data.actualArrivalPlaceOfDelivery = actualArrivalPlaceOfDelivery
  }
  get estimatedCustomsReleaseTime() {
    return this._data.estimatedCustomsReleaseTime
  }
  set estimatedCustomsReleaseTime(estimatedCustomsReleaseTime) {
    this._data.estimatedCustomsReleaseTime = estimatedCustomsReleaseTime
  }
  get destPortCustomsClearanceTime() {
    return this._data.destPortCustomsClearanceTime
  }
  set destPortCustomsClearanceTime(destPortCustomsClearanceTime) {
    this._data.destPortCustomsClearanceTime = destPortCustomsClearanceTime
  }
  get estimatedPickUpTime() {
    return this._data.estimatedPickUpTime
  }
  set estimatedPickUpTime(estimatedPickUpTime) {
    this._data.estimatedPickUpTime = estimatedPickUpTime
  }
  get actualPickUpTime() {
    return this._data.actualPickUpTime
  }
  set actualPickUpTime(actualPickUpTime) {
    this._data.actualPickUpTime = actualPickUpTime
  }
  get estimatedDeliveryToWarehouseTime() {
    return this._data.estimatedDeliveryToWarehouseTime
  }
  set estimatedDeliveryToWarehouseTime(estimatedDeliveryToWarehouseTime) {
    this._data.estimatedDeliveryToWarehouseTime = estimatedDeliveryToWarehouseTime
  }
  get deliveryTime() {
    return this._data.deliveryTime
  }
  set deliveryTime(deliveryTime) {
    this._data.deliveryTime = deliveryTime
  }
  get destPortDeliveryTime() {
    return this._data.destPortDeliveryTime
  }
  set destPortDeliveryTime(destPortDeliveryTime) {
    this._data.destPortDeliveryTime = destPortDeliveryTime
  }
  get deliveryCompletionDate() {
    return this._data.deliveryCompletionDate
  }
  set deliveryCompletionDate(deliveryCompletionDate) {
    this._data.deliveryCompletionDate = deliveryCompletionDate
  }
  get estimatedReturnTime() {
    return this._data.estimatedReturnTime
  }
  set estimatedReturnTime(estimatedReturnTime) {
    this._data.estimatedReturnTime = estimatedReturnTime
  }
  get destPortReturnTime() {
    return this._data.destPortReturnTime
  }
  set destPortReturnTime(destPortReturnTime) {
    this._data.destPortReturnTime = destPortReturnTime
  }
  get importManifest() {
    return this._data.importManifest
  }
  set importManifest(importManifest) {
    this._data.importManifest = importManifest || false
  }

  /* 关联实体-begin */
  get cargoDoc() {
    return this._data.cargoDoc
  }
  set cargoDoc(cargoDoc) {
    this._data.cargoDoc = this._data.seaCargoDoc = cargoDoc
  }
  get seaCargoDoc() {
    return this._data.seaCargoDoc
  }
  set seaCargoDoc(seaCargoDoc) {
    this._data.seaCargoDoc = this._data.cargoDoc = seaCargoDoc
  }

  get customClaim() {
    return this._data.customClaim
  }
  set customClaim(customClaim) {
    this._data.customClaim = customClaim || -1
  }

  get carrierScac() {
    return this._data.carrierScac
  }
  set carrierScac(carrierScac) {
    this._data.carrierScac = carrierScac
  }
  /* 关联实体-end */

  // 加载海出Job的关联实体信息
  async loadJobRelated(params) {
    params.jobUuid = params.jobUuid || this._data.uuid
    if (!params.jobUuid) {
      return
    }
    // 是否需要载入
    let needLoad = false
    // 将已经加载过的属性的标识置为false
    for (const key in params) {
      if (key === 'jobUuid') {
        continue
      }
      if (params[key] && typeof this._data[key] === 'object') {
        params[key] = false
      }
      if (params[key]) {
        needLoad = true
      }
    }
    if (!needLoad) {
      return
    }
    await loadseaImportJobRelated(params).then(res => {
      const items = res.data
      if (items.job) {
        for (const key in items.job) {
          if (typeof this._data[key] === 'object') {
            continue
          }
          this._data[key] = items.job[key]
        }
      }
      for (const key in items) {
        if (key === 'job') {
          continue
        }
        if (key === 'lclSlaves') {
          items[key] = sortByMultiFieldAndOrder(items[key], { jobNo: 'asc', dateCreated: 'desc' })
        }
        this._data[key] = items[key] || null
      }
    })
    this.syncCargoDoc()
    this.checkCargoDoc()
  }
  // 加载海出Job的关联实体信息
  async loadJobRelated2(params) {
    params.jobUuid = params.jobUuid || this._data.uuid
    if (!params.jobUuid) {
      return
    }
    this.syncCargoDoc()
    await loadseaImportJobRelated(params).then(res => {
      const items = res.data
      if (items.job) {
        for (const key in items.job) {
          if (typeof this._data[key] === 'object') {
            continue
          }
          this._data[key] = items.job[key]
        }
      }
      for (const key in items) {
        if (key === 'job') {
          continue
        }
        if (key === 'lclSlaves') {
          items[key] = sortByMultiFieldAndOrder(items[key], { jobNo: 'asc', dateCreated: 'desc' })
        }
        this._data[key] = items[key] || null
      }
    })
    this.syncCargoDoc()
  }
  // 给cargoDoc和seaCargoDoc赋同一个对象
  syncCargoDoc() {
    if (this._data.cargoDoc) {
      this._data.seaCargoDoc = this._data.cargoDoc
    } else if (this._data.seaCargoDoc) {
      this._data.cargoDoc = this._data.seaCargoDoc
    }
  }
  async getCargoDoc() {
    const data = this._data
    if (typeof data.cargoDoc !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'cargoDoc': true })
      } else {
        if (data.seaCargoDoc) {
          data.cargoDoc = data.seaCargoDoc
        } else {
          data.cargoDoc = data.seaCargoDoc = []
        }
      }
    }
    return data.cargoDoc
  }
  async getJointMasterHBL() {
    const data = this._data
    if (typeof data.jointMasterHBL !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'jointMasterHBL': true })
      }
    }
    return data.jointMasterHBL
  }

  async getSeaCargoDoc() {
    const data = this._data
    if (typeof data.seaCargoDoc !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'seaCargoDoc': true })
      } else {
        if (data.cargoDoc) {
          data.seaCargoDoc = data.cargoDoc
        } else {
          data.seaCargoDoc = data.cargoDoc = []
        }
      }
    }
    return data.seaCargoDoc
  }
  async getMainMbl(create = false) {
    const seaCargoDoc = await this.getSeaCargoDoc()
    for (const item of seaCargoDoc) {
      if (item.docType === CargoDocConsts.MBL) {
        return item
      }
    }
    if (!create) return null
    return SeaImCargoDoc.newCargoDoc(this, CargoDocConsts.MBL)
  }
  async getMainHbl(create = false) {
    const seaCargoDoc = await this.getSeaCargoDoc()
    for (const item of seaCargoDoc) {
      if (item.docType === CargoDocConsts.HBL) {
        return item
      }
    }
    if (!create) return null
    return SeaImCargoDoc.newCargoDoc(this, CargoDocConsts.HBL)
  }

  /**
   * 根据类型获取CargoDoc
   */
  async getCargoDocByType(type, create = false) {
    if (this.cargoDoc === null && !create) { return null }

    const seaCargoDoc = await this.getSeaCargoDoc()
    for (const item of seaCargoDoc) {
      if (item.docType === type) {
        return item
      }
    }
    if (!create) return null
    return SeaImCargoDoc.newCargoDoc(this, type)
  }

  copyMasterJob() {
    const data = this._data
    const job = new SeaImportJob().fillDefaultValue().getData()
    job.lclMaster = data
    job.trans = true
    job.booking = true
    job.warehousing = true
    job.warehouseCmp = data.warehouseCmp
    job.parts = true
    job.jobNo = data.jobNo
    job.lob = data.lob
    job.mbl = data.mbl
    // 主票新增小票，或加入主票的小票，海关分单号为空，则默认同步主单号。
    job.customsHbl = job.mbl
    job.cargoSource = data.cargoSource
    job.designationAgent = data.designationAgent
    job.bookingAgent = data.bookingAgent
    job.destinationAgent = data.destinationAgent
    job.carrierId = data.carrierId
    job.carrierScac = data.carrierScac
    job.vessel = data.vessel
    job.voyageFlight = data.voyageFlight
    job.secondVessel = data.secondVessel
    job.secondVoyage = data.secondVoyage
    job.etd = data.etd
    job.eta = data.eta
    job.ata = data.ata
    job.dispatchingPlace = data.dispatchingPlace
    job.loadingPortCode = data.loadingPortCode
    job.dischargingPortCode = data.dischargingPortCode
    job.destinationPortCode = data.destinationPortCode
    job.destinationPlace = data.destinationPlace
    job.transDate = data.transDate
    job.deliverDate = data.deliverDate
    job.arriveStorageDate = data.arriveStorageDate
    job.cargoEnglishName = data.cargoEnglishName
    job.cargoChineseName = data.cargoChineseName
    job.mark = data.mark
    job.containerLoadType = 'LCL'
    job.freightTermHBL = data.freightTermHBL
    job.releaseTypeMBL = data.releaseTypeMBL
    job.paymentTermMBL = data.paymentTermMBL
    job.paymentTermHBL = data.paymentTermHBL
    job.portDistrict = data.portDistrict
    job.sales = data.sales
    job.salesDepartment = data.salesDepartment
    job.salesOffice = data.salesOffice
    job.cargoSalesId = data.cargoSalesId
    job.csr = data.csr
    job.op = data.op
    job.opDepartment = data.opDepartment
    job.opOffice = data.opOffice
    job.remarks = data.remarks

    return job
  }
  // 批量复制小票，组装数据返回给前台
  // async batchCloneLcLJob() {
  //   return await batchCloneLcLJob({ jobUuid: this._data.uuid, branchId: $store.getters.currentOfficeId }).then(res => res.data)
  // }
  // 检查提单
  checkCargoDoc() {
    if (!this.seaCargoDoc) {
      return
    }
    /* 有重复的MBL、HBL，只保留uuid最小的记录(和cargo默认取值保持一致)，其他的移除 */
    const list = this.seaCargoDoc
    let mbl = null
    let hbl = null
    const deletedCargoDocs = []
    for (let i = list.length - 1; i >= 0; --i) {
      if (list[i].docType === CargoDocConsts.MBL) {
        if (!mbl || list[i].uuid < mbl.uuid) {
          mbl = list[i]
        }
        deletedCargoDocs.push(list[i])
        list.splice(i, 1)
      } else if (list[i].docType === CargoDocConsts.HBL) {
        if (!hbl || list[i].uuid < hbl.uuid) {
          hbl = list[i]
        }
        deletedCargoDocs.push(list[i])
        list.splice(i, 1)
      }
    }
    if (mbl) {
      list.push(mbl)
    }
    if (hbl) {
      list.push(hbl)
    }
    this._data.deletedCargoDocs = deletedCargoDocs.filter(p => {
      if (mbl && p.uuid === mbl.uuid) {
        return false
      }
      if (hbl && p.uuid === hbl.uuid) {
        return false
      }
      return true
    })
  }
}
